import {useTranslation} from 'react-i18next'

const usePresentationFormOptions = () => {
    const {t} = useTranslation()

    const employeesOptions = [
        {
            label: `1 - 4 ${t('demo_form_people')}`,
            value: '1-4',
        },
        {
            label: `5 - 10 ${t('demo_form_people')}`,
            value: '5-10',
        },
        {
            label: `11 - 20 ${t('demo_form_people')}`,
            value: '11-20',
        },
        {
            label: `21 - 50 ${t('demo_form_people')}`,
            value: '21-50',
        },
        {
            label: `50+ ${t('demo_form_people')}`,
            value: '50+',
        },
    ]

    return {employeesOptions}
}

export default usePresentationFormOptions
